export function initKinkezinsCircle() {
    const container = document.querySelector('.kinkezins-container');
    if (!container) return;

    const circle = container.querySelector('.kinkezins-circle');
    if (!circle) return;

    const lineStartPercent = 0.154;

    window.addEventListener('mousemove', function (e) {
        const rect = container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const minX = rect.width * lineStartPercent;

        const maxX = rect.width * 0.97;

        circle.style.display = 'block';
        const clampedX = Math.max(minX, Math.min(x, maxX));
        circle.style.left = clampedX + 'px';
    });
}